__turbopack_context__.v({
  "brighten": "animate-into-view-module-scss-module__ASi1Kq__brighten",
  "end": "animate-into-view-module-scss-module__ASi1Kq__end",
  "fadeIn": "animate-into-view-module-scss-module__ASi1Kq__fadeIn",
  "isLoading": "animate-into-view-module-scss-module__ASi1Kq__isLoading",
  "slideDown": "animate-into-view-module-scss-module__ASi1Kq__slideDown",
  "slideUp": "animate-into-view-module-scss-module__ASi1Kq__slideUp",
  "start": "animate-into-view-module-scss-module__ASi1Kq__start",
  "wacky": "animate-into-view-module-scss-module__ASi1Kq__wacky",
});
